export const LanguageOptions = [
  {
    selected: true,
    value: 'HU',
    label: 'Hungarian',
  },
  {
    value: 'EN',
    label: 'English',
  },
];

export const CurrencyOptions = [
  {
    selected: true,
    value: 'HUF',
    label: 'Huf',
  },
  {
    value: 'EUR',
    label: 'Eur',
  },
];

export const PeriodOptions = [
  {
    selected: true,
    value: 'MONTH',
    label: 'Monthly',
  },
  {
    value: 'QUARTER',
    label: 'Quarterly',
  },
  {
    value: 'HALF',
    label: 'Half',
  },
  {
    value: 'YEAR',
    label: 'Yearly',
  },
];

export const emailTypeOptions = [
  {
    selected: true,
    value: 'promo',
    label: 'Promotion',
  },
  {
    value: 'annual-promo',
    label: 'Annual promo',
  },
  {
    value: 'training',
    label: 'Training',
  },
  {
    value: 'camping',
    label: 'Camping promotion',
  },
];

export const planOptions = [
  {
    selected: true,
    value: '',
    label: 'Plan',
    disabled: true,
  },
  {
    value: 'AIRBNB_PLUS',
    label: 'AIRBNB_PLUS',
  },
  {
    value: 'AIRBNB_PRO_PLUS',
    label: 'AIRBNB_PRO_PLUS',
  },
  {
    value: 'APARTMENT_BASE',
    label: 'APARTMENT_BASE',
  },
  {
    value: 'APARTMENT_PLUS',
    label: 'APARTMENT_PLUS',
  },
  {
    value: 'APARTMENT_PRO',
    label: 'APARTMENT_PRO',
  },
  {
    value: 'APARTMENT_PRO_PLUS',
    label: 'APARTMENT_PRO_PLUS',
  },
  {
    value: 'CAMPING_PRO',
    label: 'CAMPING_PRO',
  },
  {
    value: 'CAMPING_BASE',
    label: 'CAMPING_BASE',
  },
  {
    value: 'CAMPING_PLUS',
    label: 'CAMPING_PLUS',
  },
  {
    value: 'CAMPING_PRO_PLUS',
    label: 'CAMPING_PRO_PLUS',
  },
  {
    value: 'HOTEL_BASE',
    label: 'HOTEL_BASE',
  },
  {
    value: 'HOTEL_PLUS',
    label: 'HOTEL_PLUS',
  },
  {
    value: 'HOTEL_PRO',
    label: 'HOTEL_PRO',
  },
  {
    value: 'HOTEL_PRO_PLUS',
    label: 'HOTEL_PRO_PLUS',
  },
];
